import { useState } from 'react';
import { FORECAST_VIEW_TYPES } from './ViewTypeSelector/ViewTypeSelector';
import useForecastTrackingEvents from '../useForecastTrackingEvents';

const useViewType = () => {
  const [value, setValue] = useState(FORECAST_VIEW_TYPES.COLUMN_CHART);
  const trackingEvents = useForecastTrackingEvents();

  const onChange = newValue => {
    setValue(newValue);
    trackingEvents.onChangeViewType(newValue);
  };

  return {
    value,
    onChange
  };
};

export default useViewType;
